import React from "react";
import Promotions from "~/modules/promotions/promotions";
import { InternalView } from "~/components/internal-view/internal-view";
import { useTranslation } from "react-i18next";
import styles from "./partner.module.css";
import { useLoaderData } from "@remix-run/react";

export default function Index() {
  const { t } = useTranslation();
  const { promotions } = useLoaderData<any>();

  return (
    <div className={styles.wrapperContainer}>
      <InternalView
        copy={t("offers_internal_page.title")}
        breadcrumbs={[{ text: t("cataloguePromotionsMain.offers") }]}>

        <div className={styles.categoryGrid}>
          <Promotions promotions={promotions} />
        </div>
      </InternalView>
    </div>);

}